/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CitationReviewRequest = {
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept); reopen => back to 'pending', undoing either decision.
   */
  action: CitationReviewRequest.action;
};
export namespace CitationReviewRequest {
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept); reopen => back to 'pending', undoing either decision.
   */
  export enum action {
    ACCEPT = 'accept',
    DISMISS = 'dismiss',
    REOPEN = 'reopen',
  }
}

